import { Injectable } from '@angular/core';

/**
 * RouterHistory:
 * You need to subscribe to the router.events and push
 * all new NavigationStart events here to make it work.
 * Once it's everything should work fine unless you don't
 * use the angular router to redirect.
 */
@Injectable({
  providedIn: 'root',
})
export class RouterHistoryService {
  private readonly history: string[] = [];

  /**
   * Get current route event in history
   * @return string
   */
  public get current(): string {
    return this.history[0];
  }

  /**
   * Get previous route event in history
   * @return string
   */
  public get previous(): string | undefined {
    return this.history[1];
  }

  /**
   * Push route event in history
   */
  public push(url: string): void {
    if (url === this.previous) {
      this.history.shift();
      return;
    }

    this.history.unshift(url);
  }

  /**
   * Removes the latest history element
   * Useful when going back
   */
  public shift(): void {
    this.history.shift();
  }
}
